/* eslint-disable */
// *******************************************
// * text animate in
// *******************************************

import {gsap} from 'gsap/all';
import  SplitText  from "../js/SplitText.min.js";

const aniConf = {
  stagger: 0.02, // 0.05
  // stagger: 0, // 0.05
  opacity: 0 ,
  scale: 0,
  transformOriginIn: "0% 50% -50",
  transformOriginOut: "50% 50% -50",
  rotationXIn: -180,
  rotationXOut: 180,
  posYin: 80,
  posYout: -80,
  ease: 'power4.inOut',
  inTime: 0.9,
  outTime: 0.9,
  outDelay: '-=1.1',
  nextInDelay: '+=2.5',
  initialDelay: 0,
};


const adjustAniConfToScreen = () => {
  if (window.innerWidth < 1024){
    aniConf.posYin = 20;
    aniConf.posYout = -40;
  }
  if(window.innerWidth < 550){
    aniConf.posYin = -30;
    aniConf.posYout = 10;
  }
}

adjustAniConfToScreen();
window.addEventListener("resize", adjustAniConfToScreen);


const animateInOnceSingle = () => {
  const $successTxtAni = document.querySelector('.page-title-anim-single');
  // console.log($successTxtAni)
  gsap.set($successTxtAni, {perspective: 400});
  const aniTextsSplitted =  new SplitText( $successTxtAni , {type: "words, lines, chars"});
  gsap.from( aniTextsSplitted.lines, aniConf.inTime, { stagger: { each: aniConf.stagger }, opacity:aniConf.opacity, y:aniConf.posYin, scale:aniConf.scale, ease: aniConf.ease, rotationX: aniConf.rotationXIn, transformOrigin:aniConf.transformOriginIn , delay: 0 } )

}

export default animateInOnceSingle



// WEBPACK FOOTER //
// ./scripts/components/animateInOnceSingle.js